import _sfc_main from './PortfolioBreakdown.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-widget fds-portfolio-breakdown", class: { "fds-ui-loading": _setup.isLoadingStoreData, [`fds-portfolio-breakdown--${_vm.breakdownType}`]: true } }, [_vm._t("root", function() {
    return [_c(_setup.HoistComponent, [_c(_setup.UiBreakdown, _vm._g({ staticClass: "fds-portfolio-breakdown__main", attrs: { "locale": _vm.locale, "chart-type": _vm.chartType, "items": _setup.positions, "chart-options": _setup.chartOptions, "highlight-min-weight": _vm.highlightMinWeight, "highlight-max-items": _vm.highlightMaxItems, "highlight-mode": _vm.highlightMode, "table-display-others": _vm.tableDisplayOthers, "chart-display-others": _vm.chartDisplayOthers, "legend-type": _vm.legendType, "translation-keys": _setup.translationKeys }, scopedSlots: _vm._u([_vm.breakdownType === "assetClass" ? { key: "ui-name__root", fn: function(bindings) {
      return [_vm._t("name", function() {
        return [_vm._v(" " + _vm._s(_setup.translate(`portfolioBreakdown.assetClasses.${_setup.textFormat(_setup.getName(bindings))}`)) + " ")];
      }, null, bindings)];
    } } : null], null, true) }, _setup.uiBreakdownEvents()))], 1)];
  }, null, {
    localizationSupport: _setup.localizationSupport,
    storeModule: _setup.storeModule,
    chartOptions: _setup.chartOptions,
    highlightMinWeight: _vm.highlightMinWeight,
    highlightMaxItems: _vm.highlightMaxItems,
    highlightMode: _vm.highlightMode,
    tableDisplayOthers: _vm.tableDisplayOthers,
    legendType: _vm.legendType,
    uiBreakdownEvents: _setup.uiBreakdownEvents,
    positions: _setup.positions
  })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/portfolio-breakdown/PortfolioBreakdown.vue";
var PortfolioBreakdown = __component__.exports;

export { PortfolioBreakdown as default };
